module.exports = __webpack_public_path__ + "assets/mailchimp.5ab796fb.svg";